import React, { useState } from 'react';
import { AlignRight, X, ChevronRight } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const dropdownItems = [
    {
      label: 'Lung Cancer',
      href: '#',
      subItems: [
        { label: 'About Lung Cancer', href: 'https://www.icanwewill.com.my/be-informed/' },
        { label: 'Lung Cancer Treatment', href: 'https://www.icanwewill.com.my/be-informed/treatment-of-lung-cancer/' },
        { label: 'Lung Cancer Complications', href: 'https://www.icanwewill.com.my/be-informed/treatment-of-lung-cancer-complications/' },
        { label: 'LungX', href: 'https://www.icanwewill.com.my/lungx/' },
      ],
    },
    {
      label: 'TNBC',
      href: '#',
      subItems: [
        { label: 'About TNBC', href: 'https://www.icanwewill.com.my/be-informed-breast/' },
        { label: 'TNBC Treatment', href: 'https://www.icanwewill.com.my/be-informed/treatment-of-breast-cancer/' },
        { label: 'TNBC Complication', href: 'https://www.icanwewill.com.my/be-informed/treatment-of-breast-cancer-complications/' },
      ],
    },
    {
      label: 'Access To Treatment',
      href: 'https://www.icanwewill.com.my/be-informed/access-to-treatment/',
    },
    {
      label: 'Tips & Treatment',
      href: 'https://www.icanwewill.com.my/be-informed/tips-guidance-overview/',
    },
    {
      label: 'News',
      href: 'https://www.icanwewill.com.my/be-informed/in-the-news/',
    },
  ];

  return (
    <header className="header-wrap bg-[#007177] shadow-sm sticky top-0 z-50">
      <div className="header-child max-w-7xl mx-auto">
        <div className="flex justify-between h-16">
          <div className="flex">
            <div className="flex-shrink-0 flex items-center">
              <a href="https://www.icanwewill.com.my/">
                <img src="./ICWW.png" alt="ICWW" className='main-logo' />
              </a>

            </div>
          </div>

          {/* Desktop menu */}
          <nav
            className="hidden md:ml-6 md:flex md:space-x-8"
            aria-label="Primary site navigation"
          >
            {/* BE INFORMED with dropdown */}
            <div
              className="relative flex"
              onMouseEnter={() => setIsDropdownOpen(true)}
              onMouseLeave={() => setIsDropdownOpen(false)}
            >
              <a
                href="https://www.icanwewill.com.my/be-informed/"
                className="inline-flex items-center px-1 pt-1 border-b-2 border-[#007177] text-lg font-bold text-white hover:text-gray-200"
              >
                BE INFORMED
              </a>

              {/* Dropdown menu */}
              {isDropdownOpen && (
                <div className="absolute left-0 mt-0 top-[64px] w-96 bg-[#00857C] shadow-lg py-5 z-50">
                  {dropdownItems.map((item, index) => (
                    <div key={index} className="group relative w-[50%]">
                      <a
                        href={item.href}
                        className="flex items-center justify-between px-4 py-2 text-lg font-bold text-white hover:underline hover:border-gray-300"
                      >
                        <span>{item.label}</span>
                        {item.subItems && (
                          <ChevronRight
                            className="h-4 w-4 ml-2"
                            aria-hidden="true"
                            focusable="false"
                          />
                        )}
                      </a>

                      {/* Nested submenu if subItems exist */}
                      {item.subItems && (
                        <div className="absolute left-full top-0 -ml-[20px] mt-0 hidden group-hover:block w-60 bg-transparent z-50">
                          {item.subItems.map((subItem, subIndex) => (
                            <a
                              key={subIndex}
                              href={subItem.href}
                              className="block px-4 py-2 text-lg text-white hover:underline font-bold leading-5"
                            >
                              {subItem.label}
                            </a>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Other menu items */}
            <a href="https://www.icanwewill.com.my/be-inspired/" className="inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-lg font-bold text-white hover:text-gray-200 hover:border-gray-300">
              BE INSPIRED
            </a>
            <a href="https://www.icanwewill.com.my/be-involved/" className="inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-lg font-bold text-white hover:text-gray-200 hover:border-gray-300">
              BE INVOLVED
            </a>
            <a href="https://www.icanwewill.com.my/be-connected/" className="inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-lg font-bold text-white hover:text-gray-200 hover:border-gray-300">
              BE CONNECTED
            </a>
          </nav>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden">
            <button
              onClick={toggleMenu}
              className="inline-flex items-center justify-center p-2 rounded-md text-[#fff] scale-150"
            >
              <span className="sr-only">Open main menu</span>
              {isMenuOpen ? (
                <X
                  className="block h-6 w-6"
                  aria-hidden="true"
                  focusable="false"
                />
              ) : (
                <AlignRight
                  className="block h-6 w-6"
                  aria-hidden="true"
                  focusable="false"
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu, show/hide based on menu state */}
      {isMenuOpen && (
        <div className="md:hidden bg-white">
          <div className="space-y-0">
            {/* BE INFORMED main item */}
            <a
              href="https://www.icanwewill.com.my/be-informed/"
              className="block px-4 py-3 text-gray-500 bg-gray-50 text-lg font-semibold uppercase"
            >
              BE INFORMED
            </a>

            {/* BE INFORMED dropdown items */}
            <div className="bg-gray-100 px-2">
              <a
                href="https://www.icanwewill.com.my/be-informed/"
                className="block px-4 py-3 text-gray-500 bg-gray-50 text-lg font-medium uppercase"
              >
                ABOUT LUNG CANCER
              </a>
              <a
                href="https://www.icanwewill.com.my/be-informed/treatment-of-lung-cancer/"
                className="block px-4 py-3 text-gray-500 bg-gray-50 text-lg font-medium"
              >
                LUNG CANCER TREATMENT
              </a>
              <a
                href="https://www.icanwewill.com.my/be-informed/treatment-of-lung-cancer-complications/"
                className="block px-4 py-3 text-gray-500 bg-gray-50 text-lg font-medium"
              >
                LUNG CANCER COMPLICATIONS
              </a>
              <a
                href="https://www.icanwewill.com.my/lungx/"
                className="block px-4 py-3 text-gray-500 bg-gray-50 text-lg font-medium"
              >
                LUNGX
              </a>
              <a
                href="https://www.icanwewill.com.my/be-informed-breast/"
                className="block px-4 py-3 text-gray-500 bg-gray-50 text-lg font-medium"
              >
                ABOUT TNBC
              </a>
              <a
                href="https://www.icanwewill.com.my/be-informed/treatment-of-breast-cancer/"
                className="block px-4 py-3 text-gray-500 bg-gray-50 text-lg font-medium"
              >
                TNBC TREATMENT
              </a>
              <a
                href="https://www.icanwewill.com.my/be-informed/treatment-of-breast-cancer-complications/"
                className="block px-4 py-3 text-gray-500 bg-gray-50 text-lg font-medium"
              >
                TNBC COMPLICATIONS
              </a>
              <a
                href="https://www.icanwewill.com.my/be-informed/access-to-treatment/"
                className="block px-4 py-3 text-gray-500 bg-gray-50 text-lg font-medium"
              >
                ACCESS TO TREATMENT
              </a>
              <a
                href="https://www.icanwewill.com.my/be-informed/tips-guidance-overview/"
                className="block px-4 py-3 text-gray-500 bg-gray-50 text-lg font-medium"
              >
                TIPS & GUIDANCE
              </a>
              <a
                href="https://www.icanwewill.com.my/be-informed/in-the-news/"
                className="block px-4 py-3 text-gray-500 bg-gray-50 text-lg font-medium"
              >
                NEWS
              </a>
            </div>

            {/* Other main menu items */}
            <a
              href="https://www.icanwewill.com.my/be-inspired/"
              className="block px-4 py-3 text-gray-500 bg-gray-50 text-lg font-semibold uppercase"
            >
              BE INSPIRED
            </a>
            <a
              href="https://www.icanwewill.com.my/be-involved/"
              className="block px-4 py-3 text-gray-500 bg-gray-50 text-lg font-semibold uppercase"
            >
              BE INVOLVED
            </a>
            <a
              href="https://www.icanwewill.com.my/be-connected/"
              className="block px-4 py-3 text-gray-500 bg-gray-50 text-lg font-semibold uppercase"
            >
              BE CONNECTED
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;